/** Customer/org logo from subscription (Redux) or Firebase user profile. */
export function resolveCustomerLogo(userReducer, user) {
  return (
    userReducer?.logoUrl ||
    userReducer?.logo_url ||
    user?.logo_url ||
    user?.photoUrl ||
    null
  );
}
